import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import {
  DEFAULT_SLIDE_MASTER,
  Slide,
  composeSlides,
} from '@features/powerpoint';
import { contentSlideTitleText } from '../../../slides/content-slide-title-text';
import { theme } from '../../../domain/theme';
import {
  ProfileStatsOptions,
  profileStats,
} from './visitor-profile/profile-stats';
import { table } from './visitor-profile/table';
import { topDataFromReport } from './visitor-profile/top-data-from-report';
import { MISSING_VALUE } from '@constants/stats';
import { visitorProfileBackground } from '../../../images';

export const visitorProfileSlide = (
  campaignAnalyticsReport: CampaignAnalyticsReport
): Slide => {
  const topData = topDataFromReport(campaignAnalyticsReport);
  const profileStatsData: ProfileStatsOptions['data'] = [
    {
      category: 'Age Range',
      name: topData.topAgeData?.name ?? MISSING_VALUE,
      value: topData.topAgeData?.value ?? MISSING_VALUE,
    },
    {
      category: 'Gender',
      name: topData.topGenderData?.name ?? MISSING_VALUE,
      value: topData.topGenderData?.value ?? MISSING_VALUE,
    },
    {
      category: 'HH Income',
      name: topData.topIncomeData?.name ?? MISSING_VALUE,
      value: topData.topIncomeData?.value ?? MISSING_VALUE,
    },
  ];

  return composeSlides(
    {
      slideMaster: DEFAULT_SLIDE_MASTER,
      background: {
        path: visitorProfileBackground,
      },
      color: theme.colors.white,
      texts: [
        contentSlideTitleText(
          '<b>The</b> <lci>WHO:</lci> <b>Visitor Profile</b>'
        ),
        {
          text: '*Based on exposed and visitation data',
          options: {
            fontSize: 10,
            h: 0.27,
            w: 3.61,
            x: 0.38,
            y: 6.49,
          },
        },
      ],
      tables: [table(topData)],
    },
    profileStats({ data: profileStatsData })
  );
};
